import axios from "@/utils/axios.js";
/**
 *
 * @param {object} params
 * {"agentId":经纪人ID}
 */
export async function getExchangeRecords(params) {
  let url = "/pointsLog/getExchangeRecords";
  return axios.post(url, params);
}
